import React, { useEffect, useState } from 'react';
import { initOpenTelemetry } from './otel';
import { compose } from 'redux';
import { withOtelContext } from '@trp-ta-nitro/otel-react';

const OtelProvider = ({ children }) => {
  const [otelOn, setOtelOn] = useState(false);

  useEffect(() => {
    if (!otelOn) {
      initOpenTelemetry();
      setOtelOn(true);
    }
  }, []);

  return <>{children}</>;
};

export default compose(withOtelContext)(OtelProvider);
